import { Link } from 'react-router-dom';

export default function AgribusinessBanner() {
  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b51fe6c6a30212139e5d28271518fb8f.jpg"
          alt="Agribusiness Background"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-900/95 to-gray-900/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-8 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/20 backdrop-blur-sm rounded-full border border-[#3782df]/30 mb-6">
              <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
              <span className="text-[#3782df] text-sm font-medium">Agribusiness Division</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              From Seed to Market & Beyond
            </h2>

            <p className="text-base text-gray-300 mb-8 leading-relaxed">
              We partner with farmers, agribusinesses, and value chain actors to unlock growth through integrated support — from production and certification to market access and digital transformation.
            </p>

            {/* Service Pillars Checklist */}
            <div className="space-y-3 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <span className="text-sm text-gray-300">Production & Post-Harvest Management</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <span className="text-sm text-gray-300">Certification & Compliance Support</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <span className="text-sm text-gray-300">Digital Integration & Market Expansion</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <span className="text-sm text-gray-300">Financial Access & Business Development</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#3782df]"></i>
                </div>
                <span className="text-sm text-gray-300">Market Linkage & Distribution</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/agribusiness" 
                className="px-8 py-3.5 bg-[#3782df] text-white text-sm font-medium rounded-lg hover:bg-[#2968c4] transition-colors text-center whitespace-nowrap"
              >
                Explore Agribusiness
              </Link>
              <Link 
                to="/contact" 
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-lg border border-white/20 hover:bg-white/20 transition-colors text-center whitespace-nowrap"
              >
                Partner With Us
              </Link>
            </div>
          </div>

          {/* Right: Highlight Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Card 1 */}
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 bg-[#3782df]/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plant-line text-2xl text-[#3782df]"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Farm-to-Market</h3>
              <p className="text-sm text-gray-300">Complete value chain support from production to distribution</p>
            </div>

            {/* Card 2 */}
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 bg-[#3782df]/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-smartphone-line text-2xl text-[#3782df]"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">AgriTech</h3>
              <p className="text-sm text-gray-300">Digital tools for inventory, records, and market access</p>
            </div>

            {/* Card 3 */}
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 bg-[#3782df]/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-[#3782df]"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Certification</h3>
              <p className="text-sm text-gray-300">Organic, GAP, and export compliance guidance</p>
            </div>

            {/* Card 4 */}
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 bg-[#3782df]/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-funds-line text-2xl text-[#3782df]"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Finance</h3>
              <p className="text-sm text-gray-300">Access to credit, grants, and investment readiness</p>
            </div>

            {/* Featured Card - Full Width */}
            <div className="sm:col-span-2 bg-[#3782df]/10 backdrop-blur-sm rounded-xl p-6 border border-[#3782df]/30">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#3782df] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-white mb-2">Embedded Partnership Model</h3>
                  <p className="text-sm text-gray-300 mb-4">We work alongside you — from field to finance — as an integrated partner in your growth journey.</p>
                  <Link 
                    to="/agribusiness" 
                    className="inline-flex items-center gap-2 text-[#3782df] text-sm font-medium hover:gap-3 transition-all"
                  >
                    Learn More
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}